import { useState } from "react";
import { useSelector } from "react-redux";
import styles from "./PageWrapper.module.scss";
import BubbleJourneyPageLayout from "../../experiments/BubbleJourney/layouts/PageLayout";
import DefaultPageLayout from "../DefaultLayout";
import SelectionsContainer from "../../components/SelectionsContainer";

const PageWrapper = () => {
  const { ppConfig } = useSelector((state) => state.filter);
  const { experiments } = useSelector((state) => state.view);
  const { bubbleUI } = experiments;
  const [toggleOnboarding, setToggleOnboarding] = useState(false);
  const isLoading = !ppConfig;

  const Layout = bubbleUI ? BubbleJourneyPageLayout : DefaultPageLayout;

  return (
    <div
      className={`${styles.pageWrapper} ${
        isLoading ? styles["pageWrapper--loading"] : ""
      }`}
    >
      <Layout
        toggleOnboarding={toggleOnboarding}
        showOnboarding={() => setToggleOnboarding(true)}
        closeOnboarding={() => setToggleOnboarding(false)}
      >
        <SelectionsContainer
          closeOnboarding={() => setToggleOnboarding(false)}
        />
      </Layout>
    </div>
  );
};

export default PageWrapper;
